export default __webpack_public_path__ + "static/media/configr-header-logo.50d868cb.svg";